export enum PriceDisplayEnum {
  NOT_INCLUDING_TAX = "no-vat",
  INCLUDING_TAX = "vat",
  TOTAL = "total",
}
